module.exports = __webpack_public_path__ + "static/media/Sec-1_Home2_EN_Mobile.8bd05e55.png";